var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lc-iframe-content"},[_c('div',[_c('keep-alive',[_c('div',{attrs:{"id":"iframe-box"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }